var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.7998L18.7639 10.7998C20.2507 10.7998 21.2177 12.3644 20.5528 13.6942L17.0528 20.6942C16.714 21.3718 16.0215 21.7998 15.2639 21.7998L11.2462 21.7998C11.0827 21.7998 10.9198 21.7798 10.7611 21.7401L7 20.7998L7 11.7998L10.3923 6.71129C10.7886 6.11696 11 5.41864 11 4.70433C11 4.20478 11.405 3.79981 11.9045 3.79981L12 3.79981C13.1046 3.79981 14 4.69524 14 5.79981L14 10.7998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.7998L18.7639 10.7998C20.2507 10.7998 21.2177 12.3644 20.5528 13.6942L17.0528 20.6942C16.714 21.3718 16.0215 21.7998 15.2639 21.7998L11.2462 21.7998C11.0827 21.7998 10.9198 21.7798 10.7611 21.7401L7 20.7998M14 10.7998L14 5.79981C14 4.69524 13.1046 3.79981 12 3.79981L11.9045 3.79981C11.405 3.79981 11 4.20478 11 4.70433C11 5.41864 10.7886 6.11696 10.3923 6.71129L7 11.7998L7 20.7998M14 10.7998L12 10.7998M7 20.7998L5 20.7998C3.89543 20.7998 3 19.9044 3 18.7998L3 12.7998C3 11.6952 3.89543 10.7998 5 10.7998L7.5 10.7998",
    stroke: "#4318FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeEmpty);
export default __webpack_public_path__ + "static/media/like-empty.ef296af6858eeaffd1e8214966e76435.svg";
export { ForwardRef as ReactComponent };